<template>
  <div class="driver-panel-scheduled" :class="$store.state.theme">
    <div class="wrapper no-scrollbar">
      <div class="header" @click="close">
        <p class="has-text-left title is-5">
          <i class="fa fa-chevron-left" style="margin-right: 10px" />
          <span>{{ $t("logistics.scheduled") }}</span>
        </p>
        <!-- <div class="delete-btn" @click="close">
          <button class="delete is-large" />
        </div> -->
      </div>

      <UpcomingJobsList />
    </div>
  </div>
</template>

<script>
import UpcomingJobsList from "@/components/UpcomingJobsList.vue";

export default {
  name: "DriverPanel2",
  components: { UpcomingJobsList },
  data() {
    return {
      hasNewPassenger: false, // bool for showing new passenger panel
      newTransactions: null, // transactions to show in new passenger panel
      driverPollInterval: null,
      acknowledged: {},
      isUpdating: false,
    };
  },
  computed: {
    role() {
      return this.$store.getters.getDriverRole;
    },
    nJobs() {
      if (this.tab === "ongoing") {
        return this.$store.getters.getWorkerTransactionsStateConfirmed.length;
      } else {
        return this.$store.getters.getWorkerTransactionsStateScheduled.length;
      }
    },
    hasNewWorkerTransactions() {
      var transactions = this.$store.getters.getWorkerTransactionsStateNew;
      if (!transactions) return false;
      if (transactions.length === 0) return false;
      if (this.blockNewTransactions) return false;
      return true;
    },
    hasCancelledTransactions() {
      var cancelled = this.$store.getters.getWorkerTransactionsStateCancelled;
      if (cancelled.length > 0) return true;
      return false;
    },
    blockNewTransactions() {
      // don't block new transactions if worker is dispatcher
      if (this.isWorkingDispatcher()) return false;
      // don't block if nearby drivers not set
      var transactions = this.$store.getters.getWorkerTransactionsStateNew;
      if (!transactions[0].data.nearby_drivers) return false;
      // don't block if driver doesn't have an ongoing job
      if (!this.$store.getters.driverHasOngoingPassengers) return false;
      // otherwise block any new transactions from appearing
      this.console("blocked New Transactions!!!");
      return true;
    },
  },
  created() {
    this.console("DriverPanelScheduled.vue created");
    // this.$store.subscribe(mutation => {
    //   if (mutation.type === "setTransactionsForWorker") {
    //     if (this.hasCancelledTransactions) {
    //       EventBus.$emit("CLOSE_PASSENGER_DETAIL", true);
    //     }
    //     this.checkAcknowledgeRequired();
    //     // this.checkETARequired(); // TODO popup ETA input for driver if necessary
    //     if (this.hasNewWorkerTransactions) {
    //       this.updateDriversAutocomplete(); // only for dispatcher
    //       this.hasNewPassenger = true;
    //       this.newTransactions = this.$store.getters.getWorkerTransactionsStateNew;
    //       // EventBus.$emit("CLOSE_PASSENGER_DETAIL", true);
    //       setTimeout(() => EventBus.$emit("DRIVER_FIT_LAYER"), 600);
    //     } else {
    //       this.hasNewPassenger = false;
    //     }
    //   }
    // });
  },
  mounted() {
    // EventBus.$on("OPEN_DRIVER_PANEL_SCHEDULED", () => (this.closed = false));
  },
  activated() {},
  deactivated() {
    this.close();
  },
  methods: {
    close() {
      this.closed = true;
      this.$emit("closed");
    },
    tabClass(tabName) {
      if (this.tab === tabName) return "active-tab has-text-link";
      return null;
    },
    setTab(tab) {
      this.tab = tab;
      if (tab === "scheduled") {
        var scheduledMsg = `<i class='fa fa-clock'></i>&nbsp;${this.nJobs} scheduled jobs`;
        this.successToast(scheduledMsg, "top");
      } else {
        this.infoToast("Completed jobs coming soon!");
      }
    },
    checkAcknowledgeRequired() {
      var txns = this.$store.getters.getWorkerTransactionsStateConfirmed;
      var t = txns.find(
        (t) =>
          t.data.hasOwnProperty("acknowledged") &&
          !t.data.acknowledged &&
          t.handled_by === this.userID() &&
          !this.acknowledged[t.id]
      );
      if (!t) return; // no transactions require acknowledgement
      var txt = this.$t("driver.please-acknowledge");
      this.$swal({
        title: `${this.$t("driver.new-dispatch")}<br>${txt}<br>👌🏼`,
        text: this.$t("driver.if-unable-cancel"),
      }).then(() => {
        this.acknowledged[t.id] = true;
        this.$store
          .dispatch("patchTransaction", {
            transactionID: t.id,
            data: { data: { acknowledged: true } },
          })
          .catch((err) => {
            this.acknowledged[t.id] = false;
            console.error("acknowledge dispatch", err);
          });
        this.thankYou();
      });
    },
  },
};
</script>

<style scoped>
.driver-panel-scheduled {
  position: absolute;
  top: 0;
  width: 100vw;
  height: 100vh;
  /* background-color: #f5d252ae; */
  /* background-color: #f0be45; */
  background-color: rgba(251, 243, 206, 0.5);
  z-index: 21;
  /* random z-index higher than modal << nope, higher than back button which is 20 */
  backdrop-filter: blur(5px);
  overflow: hidden;
}
/* .wrapper {
  padding: 12px;
  text-align: left;
  height: 100vh;
} */
.wrapper {
  z-index: 2;
  position: absolute;
  height: 100vh;
  width: 100vw;
  /* border-top-right-radius: 12px;
  border-top-left-radius: 12px; */
  box-shadow: 0 0 3px black;
  /* top: 0; */
  overflow: hidden;
  background-color: whitesmoke;
  color: #fff;
  /* transition: all 0.6s; */
}
/* .wrapper.close {
  top: 100%;
  height: 0;
} */
/* .dark .wrapper {
  background-color: #123;
  border-top-right-radius: 12px;
  border-top-left-radius: 12px;
  color: white;
} */
.header {
  padding: 5px;
  /* background-color: #f5d252; */
  background-color: #bbb;
  /* box-shadow: 0px -1px 1px rgba(100, 100, 100, 0.2); */
}
.tab {
  color: rgba(128, 128, 128, 0.66);
  font-weight: 500;
  /* font-size: 1.2em; */
  /* padding: 16px; */
  /* margin-top: -10px; */
}
.active-tab {
  font-weight: 600;
}
/* .tab:active {
  font-size: 1.2em;
} */
@keyframes shadow-pulse {
  0% {
    box-shadow: 0 0 0 0px rgba(247, 211, 8, 0.95);
  }
  100% {
    box-shadow: 0 0 0 10px rgba(247, 211, 8, 0.5);
  }
}
.pulse {
  animation: shadow-pulse 1s infinite;
  border-radius: 50%;
}
.toggle {
  padding: 5px 8px;
  /* border-top-right-radius: 50%;
  border-top-left-radius: 50%; */
  background-color: #feeaa4;
  filter: drop-shadow(2px 2px 2px #666);
}
.delete-btn {
  position: absolute;
  right: 0;
  top: 0;
  padding: 10px;
}
.title {
  padding: 10px;
  /* margin-left: 50px; */
  margin-bottom: 0;
}
</style>